const allRoutes = [
  {
    name: 'user-icon',
    permissions: [],
    icon: 'user-icon',
    label: 'Мой профиль',
    to: '',
    items: [
      {
        name: 'user-profile',
        permissions: [],
        icon: 'user-icon',
        label: 'Мой профиль',
        to: '/user-profile',
      },
      {
        name: 'user-requests',
        permissions: [],
        icon: 'user-requests-icon',
        label: 'Обращения',
        to: '/user-requests',
      },
    ],
  },
  {
    name: 'repairs-icon',
    permissions: [],
    icon: 'repairs-icon',
    label: 'Ремонты',
    to: '',
    items: [
      {
        name: 'repairs-metrics',
        permissions: ['repair'],
        icon: 'repairs-icon',
        label: 'Ремонты',
        to: '/repairs-metrics',
      },
      {
        name: 'equipment',
        permissions: ['equipment'],
        icon: 'videozones-icon',
        label: 'Оборудование',
        to: '/equipment',
      },
      {
        name: 'equipment-type',
        permissions: ['equipment'],
        icon: 'videozones-icon',
        label: 'Типы оборудования',
        to: '/equipment-type',
      },
      {
        name: 'network-schedule',
        permissions: ['demo'],
        icon: 'projects-icon',
        label: 'Сетевой график',
        to: '/network-schedule',
      },
    ],
  },
  {
    name: 'projects-and-tasks',
    permissions: ['task', 'project'],
    icon: 'projects-icon',
    label: 'Проекты и рабочие задания',
    to: '/projects-and-tasks',
  },
  {
    name: 'warehouses-icon',
    permissions: [],
    icon: 'videozones-icon',
    label: 'МТР',
    items: [
      {
        name: 'instruments',
        permissions: ['instrument'],
        icon: 'repairs-icon',
        label: 'Типы инструментов',
        to: '/instruments',
      },
      {
        name: 'warehouses',
        permissions: ['warehouse'],
        icon: 'videozones-icon',
        label: 'Инструменты на складе',
        to: '/warehouses',
      },
      {
        name: 'discard-warehouses',
        permissions: ['warehouse-write-off'],
        icon: 'instrument-work-zone-icon',
        label: 'Инструменты на проверке',
        to: '/discard-warehouses',
      },
    ],
  },
  {
    name: 'control-icon',
    permissions: [],
    icon: 'warehouses-icon',
    label: 'ЗВО',
    items: [
      {
        name: 'control-zones',
        permissions: ['module-checkpoint'],
        icon: 'modules-icon',
        label: 'Контрольные точки',
        to: '/control-zones',
      },
      {
        name: 'control-logs',
        permissions: [],
        requiredRoles: ['inspector'],
        icon: 'instrument-work-zone-icon',
        label: 'Журнал контролёров',
        to: '/control-logs',
      },
      {
        name: 'rpdz-log',
        permissions: ['rpdz'],
        icon: 'projects-icon',
        label: 'Журнал РПДЗ',
        to: '/rpdz-log',
      },
      {
        name: 'visit-log',
        permissions: [],
        icon: 'projects-icon',
        label: 'Журнал посещений',
        to: '/visit-log',
      },
      {
        name: 'visit-history',
        permissions: [],
        icon: 'projects-icon',
        label: 'Архив посещений',
        to: '/visit-history',
      },
    ],
  },
  {
    name: 'modules',
    permissions: ['module'],
    icon: 'modules-icon',
    label: 'Модули',
    to: '/modules',
  },
  {
    name: 'users-icon',
    permissions: [],
    icon: 'users-icon',
    label: 'Пользователи',
    items: [
      {
        name: 'users-list',
        permissions: ['user'],
        icon: 'user-icon',
        label: 'Пользователи',
        to: '/users-list',
      },
      {
        name: 'positions',
        permissions: ['position'],
        icon: 'positions-icon',
        label: 'Должности',
        to: '/positions',
      },
      {
        name: 'roles',
        permissions: ['role'],
        icon: 'roles-icon',
        label: 'Роли',
        to: '/roles',
      },
      {
        name: 'brigades',
        permissions: ['brigades'],
        icon: 'users-icon',
        label: 'Бригады',
        to: '/brigades',
      },
      {
        name: 'teams',
        permissions: ['team'],
        icon: 'teams-icon',
        label: 'Команды',
        to: '/teams',
      },
    ],
  },
  {
    name: 'workzones-icon',
    permissions: [],
    icon: 'workzones-icon',
    label: 'Зоны работ',
    items: [
      {
        name: 'work-zone',
        permissions: ['work-zone'],
        icon: 'videozones-icon',
        label: 'Видеозоны',
        to: '/work-zone',
      },
      {
        name: 'video-views',
        permissions: ['video-wall'],
        icon: 'videowall-icon',
        label: 'Видеостена',
        to: '/video-views',
      },
      {
        name: 'video-source',
        permissions: ['video-source'],
        icon: 'videosources-icon',
        label: 'Источники видео',
        to: '/video-source',
      },
      {
        name: 'video-wall',
        permissions: ['video-wall'],
        icon: 'videowall-icon',
        label: 'Видеоконтроль',
        to: '/video-wall',
      },
      {
        name: 'video-sync',
        permissions: ['demo'],
        icon: 'videozones-icon',
        label: 'Разметка видеозоны',
        to: '/video-sync',
      },
    ],
  },

  {
    name: 'purchase-icon',
    permissions: [],
    icon: 'purchase-icon',
    label: 'Закупки',
    items: [
      {
        name: 'analytics',
        permissions: [],
        icon: 'analytics-icon',
        label: 'Аналитика',
        to: '/analytics',
      },
      {
        name: 'client-portal',
        permissions: [],
        icon: 'client-portal-icon',
        label: 'Кабинет заказчика',
        to: '/client-portal',
      },
    ],
  },

  {
    name: 'sign-out',
    permissions: [],
    icon: 'logout-icon',
    label: 'Выход',
    to: '/sign-out',
  },
]

const permissionActions = ['list', 'show', 'create', 'update', 'delete']

const calcPermission = (permissions: any[], accesses: any, requiredRoles: string[] = [], userRoles: string[] = []) => {
  if (requiredRoles.length) {
    const hasRole = requiredRoles.some(role => userRoles.includes(role))
    if (!hasRole) return false
  }

  if (!permissions.length) return true
  return permissions.every(permission => {
    if (accesses?.[permission] && accesses?.[permission].includes(null)) return true
    return (
      accesses?.[permission]?.includes('list') &&
      accesses?.[permission]?.find((action: string) => {
        return permissionActions.some(permissionAction => action === permissionAction)
      })
    )
  })
}

const recursFilterItems = (items: any[], accesses: any, userRoles: string[]) => {
  return items
    .map((item: any) => {
      if (item?.items?.length) {
        item.items = recursFilterItems(item.items, accesses, userRoles)
      }
      return item
    })
    .filter((item: any) => {
      return calcPermission(item.permissions, accesses, item.requiredRoles || [], userRoles)
    })
}

export const calculateRoutes = (accesses: any, userRoles: string[] = []) => {
  const filterRouts = recursFilterItems(allRoutes, accesses, userRoles)
  return filterRouts.reduce((acc, item) => {
    if (!item?.items || item?.items?.length > 1) acc.push(item)
    if (item?.items?.length === 1) acc.push(item.items[0])
    return acc
  }, [])
}
